import { FullWidthContainer } from "../../common/components/layout/Container";
import Heading from "../../common/components/ui/Heading";
import Paragraph from "../../common/components/ui/Paragraph";
import { Pill } from "../../common/components/ui/Pill";
import { useMarketingData } from "../../common/hooks/firebaseHooks";
import { GoToQuestionnaireButton } from "../questionnaire/GoToQuestionnaireButton";
import { useTranslation } from "react-i18next";

type Props = {
  sectionTanslationKey: string;
};

const LandingPageArticleSection = ({ sectionTanslationKey }: Props) => {
  const { t } = useTranslation(["frontpage"]);
  const { data } = useMarketingData();

  return (
    <section className="flex flex-col-reverse md:flex-row flex-start gap-3 child:md:basis-1/2 pb-6 lg:py-16">
      <div className="my-auto space-y-2">
        <div className="flex items-center">
          <Heading
            level={2}
            type="headline-md-b"
            className="text-green-dark grow"
          >
            {t(`${sectionTanslationKey}.title`)}
          </Heading>
        </div>

        {t(`${sectionTanslationKey}.text`)
          .split("\n")
          .filter((item) => item)
          .map((segment) => (
            <Paragraph type="body-lg" key={segment} className="first:mt-0 mt-4">
              {segment}
            </Paragraph>
          ))}
      </div>
      <div className="flex flex-col gap-3 justify-center self-center w-full max-w-[480px]">
        <Pill
          size="large"
          className="self-start"
          text={
            <span className="font-bold">
              {t("infoPill1", {
                totalTests: data?.totalTests.toLocaleString("fr-FR"),
              })}
            </span>
          }
        />
        <Pill
          size="medium"
          className="self-end"
          text={
            <span>
              {t("infoPill2")}{" "}
              <span className="font-bold">
                {Math.round(data?.averageTotalFootPrint ?? 0)} kgC02e
              </span>
            </span>
          }
        />
        <Pill
          size="medium"
          className="self-start"
          text={
            <span>
              {t("infoPill3")}{" "}
              <span className="font-bold">
                {Math.round(data?.percentReductionPerPlan ?? 0)} %
              </span>
            </span>
          }
        />
      </div>
    </section>
  );
};

export const LandingPageArticle = () => {
  const { t } = useTranslation(["frontpage"]);
  const { data } = useMarketingData();

  return (
    <FullWidthContainer>
      <article className="flex flex-col-reverse md:flex-col">
        <LandingPageArticleSection
          // change the key to something else
          sectionTanslationKey="heroArticle"
        />

        <div className="flex flex-col gap-5 bg-yellow-80 px-6 py-9 text-center rounded-lg items-center mb-8">
          <Heading
            level={2}
            type="headline-lg-eb"
            className="mb-4 md:mb-0 text-neutral-100 md:mr-6"
          >
            {t("areYouReady")}
          </Heading>
          <p className="body-lg-b">
            {t("startYourActionPlan", {
              totalTests: data?.totalTests.toLocaleString("fr-FR"),
            })}
          </p>

          <GoToQuestionnaireButton
            trackLocation="home-article"
            theme="blackCTA"
          />
        </div>
      </article>
    </FullWidthContainer>
  );
};
